<style scoped lang="css">
    #login {
        height: 50%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>
<template>
    <v-app id="login" class="yoprimary" style="background-color: #00a650">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg3 xl3 style="text-align: center">
                        <img src="/img/logo_frontend.png" :alt="$t('lang.header.title')" width="" height="120">
                        <v-card class="elevation-1 pa-3" v-if="step==0">
                            <v-card-text>
                                <div class="layout column align-center">
                                    <h1 class="flex my-4">{{ $t('lang.user.forgotPassword') }}</h1>
                                </div>
                                <v-form @submit.prevent="handleSubmit">
                                    <v-text-field v-validate="'required|checkPhoneOrEmail'"
                                                  append-icon="person"
                                                  name="login"
                                                  key="login"
                                                  :label="$t('lang.user.username')"
                                                  type="text" v-model="username"
                                                  :data-vv-as="$t('lang.user.username')"
                                                  :error-messages="errors.first('login')"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <!--lang-switcher></lang-switcher-->
                                <v-spacer></v-spacer>
                                <v-btn class="yoprimary" dark @click="handleSubmit">{{ $t('lang.common.sendCode') }}
                                </v-btn>
                                <v-btn color="cancel" dark @click="cancel">{{ $t('lang.common.back') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card class="elevation-1 pa-3" v-else>
                            <v-card-text>
                                <div class="layout column align-center" style="margin-bottom: 20px">
                                    <div class="flex">{{ title }}</div>
                                </div>
                                <v-form @submit.prevent="verifyCode">
                                    <v-text-field v-validate="'required'"
                                                  name="code"
                                                  key="code"
                                                  :label="$t('lang.common.code')"
                                                  type="text" v-model.trim="code"
                                                  :data-vv-as="$t('lang.common.code')"
                                                  :error-messages="errors.first('code')"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <!--lang-switcher></lang-switcher-->
                                <div style="width: 100%;text-align: center">
                                    <v-btn class="yoprimary" dark @click="verifyCode">{{ $t('lang.common.continue') }}
                                    </v-btn>
                                    <br/>
                                    <v-btn flat class="primaryColor" @click="cancel">{{ $t('lang.common.cancel') }}</v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import LangSwitcher from "../components/header/LangSwitcher";
    import {message} from '../services';
    import axios from "axios"
    import {Validator} from "vee-validate";

    export default {
        components: {
            LangSwitcher
        },
        data() {
            return {
                step: 0,
                title: "",
                code: '',
                username: '',
                submitted: false
            }
        },
        beforeCreate() {
            //window.location = process.env.VUE_APP_API_URL + '/auth';
        },
        created() {
            if (this.$store.state.auth.loggedIn) {
                this.$router.push('/HomePage');
            }
            // reset login status
            //this.$store.dispatch('auth/logout');
        },
        mounted() {
            Validator.extend("checkPhoneOrEmail", {
                    validate(value) {
                        try {
                            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                                return true;
                            } else {
                                let phoneno = /^\d{5,11}$/;
                                if (value.match(phoneno)) {
                                    return true;
                                }
                            }
                            return false;
                        } catch (e) {
                            return false;
                        }
                    },

                    getMessage: field => {
                        return field + " không đúng định dạng";
                    },
                }
            );
            this.checkParam();
        },
        methods: {
            checkParam() {
                let userName = this.$route.params.userName;
                if (userName != undefined && userName != null) {
                    this.username = userName;
                    this.step = 1;
                    this.handleSubmit();
                }
            },

            handleSubmit(e) {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    this.submitted = true;
                    const {username} = this;
                    if (username) {
                        axios.post(process.env.VUE_APP_API_URL + "/user/forget/" + username).then(
                            data => {
                                if (data.success) {
                                    message.success("Đã gửi mã thành công");
                                    this.title = data.description;
                                    this.step = 1;
                                    //this.$router.push("/login");
                                } else {
                                    message.error(this.$t(data.description));
                                }
                            }
                        )
                    }
                });
            },

            verifyCode(e) {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    this.submitted = true;
                    let user = {userName: this.username, verify: this.code};
                    axios.post(process.env.VUE_APP_API_URL + "/verifyCode", user).then(
                        data => {
                            if (data.success) {
                                this.$router.push("/resetPass/" + this.code + "/" + this.username);
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )

                });
            },

            cancel: function () {
                this.$router.go(-1);
            }
        }
    };
</script>

